import { render, staticRenderFns } from "./AssetEditor.vue?vue&type=template&id=6ace53da&scoped=true"
import script from "./AssetEditor.vue?vue&type=script&lang=js"
export * from "./AssetEditor.vue?vue&type=script&lang=js"
import style0 from "./AssetEditor.vue?vue&type=style&index=0&id=6ace53da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ace53da",
  null
  
)

export default component.exports